import { ActionIcon, Flex, Paper, Text } from '@mantine/core';
import { IconTrashX as DeleteIcon, IconDownload, IconFile } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { PersistentFile } from '@feature/utils';
import { humanFileSize } from '@feature/utils/humanFileSize';

export interface FileCardProps {
  file: PersistentFile;

  onDownload?: () => void;
  onRemove?: () => void;
  disabled?: boolean;
}

export function FileCard({ file, onDownload, onRemove, disabled }: FileCardProps) {
  const { title, sizeInBytes } = file;
  const { t } = useTranslation();
  return (
    <Paper
      p="xs"
      withBorder
    >
      <Flex
        align="center"
        justify="space-between"
      >
        <Flex align="center">
          <IconFile
            size="25px"
            color="#5277b7"
          />
          <Text
            ml="5px"
            size="sm"
          >
            {title}
          </Text>
        </Flex>
        <Flex
          align="center"
          gap="10px"
        >
          {sizeInBytes && (
            <Text
              ml="10px"
              size="sm"
              c="dimmed"
              fw="500"
            >
              {humanFileSize(sizeInBytes)}
            </Text>
          )}
          {onDownload && (
            <ActionIcon
              mr="5px"
              onClick={onDownload}
              variant="filled"
              bg="primary"
              aria-label={t('button.download')}
            >
              <IconDownload
                style={{ width: '70%', height: '70%' }}
                stroke={1.5}
              />
            </ActionIcon>
          )}
          {onRemove && (
            <ActionIcon
              disabled={disabled}
              mr="5px"
              onClick={onRemove}
              variant="filled"
              bg="red"
              aria-label={t('button.delete')}
            >
              <DeleteIcon
                style={{ width: '70%', height: '70%' }}
                stroke={1.5}
              />
            </ActionIcon>
          )}
        </Flex>
      </Flex>
    </Paper>
  );
}
